module.exports = __webpack_public_path__ + "static/media/ice-cream.c862ff9d.svg";